import React from "react";
import PropTypes from "prop-types";
import { ASSET_TYPES } from "utils/constants";

import AssetsTable from "widgets/table/AssetsTable";

import "./DeleteAsset.css";

export default function DeleteAsset(props){
	const { assets } = props;

	return (
		<div className="delete-assets-body scrolling-modal-body">
			<header className="delete-header">Are you sure you want to delete the selected {props.assetType}?</header>
			<div className="delete-asset-table">
				<AssetsTable assets={assets} />
			</div>
		</div>
	);
}

DeleteAsset.displayName = "DeleteAsset";
DeleteAsset.defaultProps = {
	assetType:"",
	assets:[],
};

DeleteAsset.propTypes = {
	assetType:PropTypes.oneOf(
		Object.values(ASSET_TYPES)
			.reduce((prev, val) => [...prev, val, val.toLowerCase()], ["assets"])
	).isRequired,
	assets:PropTypes.array.isRequired,
};
